const API = () => "https://" + window.location.hostname + ":44348/api";

export { API };
